/*
 * 获取客户本人其他手机号 *
 * *
 * */
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { GetCustomerOtherMobileReq, SaveWhatsappFlagReq} from "@/pbjs/xcommon/collection_pb"
import InnerRequest from "./request";
export interface Options {
    ItemId: number;
    OrderId: string;
    AccountId: string;
    Identity: string;
    PhoneObject:string;
    HaveWhatsapp:number;
    TicketId:number
}
export function setReq(arg: Options) {
    let request: any = new GetCustomerOtherMobileReq();
    request.setItemid(arg.ItemId);
    request.setOrderid(arg.OrderId);
    request.setAccountid(arg.AccountId); // accountbase 的id
    request.setIdentity(arg.Identity);
    return request;
}
export const getCustomerOtherMobileRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.getCustomerOtherMobile
);


export function setSaveWhatsappFlagReq(arg: Options) {
    let request: any = new SaveWhatsappFlagReq();
    request.setItemid(arg.ItemId);
    request.setTicketid(arg.TicketId);
    request.setPhoneobject(arg.PhoneObject); // accountbase 的id
    request.setHavewhatsapp(arg.HaveWhatsapp);
    return request;
}
export const saveWhatsappFlagReqRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.saveWhatsappFlag
);
